import { Copy } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";

interface Props {
  // 고객 「내 현장」 절대 URL — 화면에 찍지 않고 복사만 한다. null 이면 reason 을 달고 막는다.
  url: string | null;
  reason: string | null;
}

// 현장 상세의 「고객 보기 링크 복사」 — 계약 링크(토큰) 아래 /project 를 복사한다.
const CustomerLinkButton = ({ url, reason }: Props) => {
  const copy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("고객 보기 링크를 복사했습니다");
    } catch {
      toast.error("복사하지 못했습니다");
    }
  };

  return (
    <span title={url ? undefined : reason ?? undefined}>
      <Button data-testid="project-customer-link" disabled={!url} size="sm" type="button" variant="outline" onClick={copy}>
        <Copy className="size-4" />
        고객 보기 링크 복사
      </Button>
    </span>
  );
};

export default CustomerLinkButton;
